import React from "react";
import { Typography, Divider } from "@mui/material";

type GlobalSearchSectionTitleProps = {
  title: string;
};

const GlobalSearchSectionTitle = ({ title }: GlobalSearchSectionTitleProps) => {
  return (
    <>
      <Divider sx={{ color: "text.secondary", marginY: 1 }} />
      <Typography
        sx={{
          fontSize: "10px",
          letterSpacing: ".6px",
          fontWeight: 400,
          textTransform: "uppercase",
        }}
        data-test-id="gs-section-title"
      >
        {title}
      </Typography>
      <Divider sx={{ color: "text.secondary", marginY: 1 }} />
    </>
  );
};

export default GlobalSearchSectionTitle;
